export default __webpack_public_path__ + "static/media/kinken.9f5754c5.png";